// Korean translations
const ko = {
  cover: {
    title: "체스 왕국",
    subtitle: "왕의 궁정",
    riseOfDukes: "공작의 부상",
    enter: "입장",
    aboutUs: "소개",
    tagline: "전설이 태어나는 곳, 모든 수가 이야기를 전합니다",
    selectLanguage: "언어 선택"
  },
  auth: {
    login: "로그인",
    register: "회원가입",
    email: "이메일",
    password: "비밀번호",
    confirmPassword: "비밀번호 확인",
    username: "사용자명",
    forgotPassword: "비밀번호를 잊으셨나요?",
    noAccount: "계정이 없으신가요?",
    hasAccount: "이미 계정이 있으신가요?",
    signUp: "가입하기",
    signIn: "로그인",
    orContinueWith: "또는 계속하기",
    guest: "게스트로 플레이",
    logout: "로그아웃"
  },
  lobby: {
    title: "로비",
    subtitleRise: "공작의",
    subtitleDukes: "부상",
    quickPlay: "빠른 대국",
    createRoom: "방 만들기",
    joinRoom: "참가",
    settings: "설정",
    skins: "스킨",
    friends: "친구",
    chat: "채팅",
    spectate: "관전",
    roomCode: "방 코드",
    enterRoomCode: "코드 입력...",
    join: "참가",
    create: "생성",
    private: "비공개",
    public: "공개",
    players: "플레이어",
    waiting: "상대 대기 중...",
    ready: "준비 완료",
    start: "시작",
    gameSetup: "게임 설정",
    chooseVariant: "변형 및 모드 선택",
    multiplayer: "멀티플레이",
    onlineMatches: "온라인 대국",
    profile: "프로필",
    messages: "메시지",
    assistant: "어시스턴트",
    help: "도움말",
    exit: "나가기"
  },
  game: {
    white: "백",
    black: "흑",
    whiteToMove: "백의 차례",
    blackToMove: "흑의 차례",
    check: "체크!",
    checkmate: "체크메이트!",
    stalemate: "스테일메이트!",
    draw: "무승부",
    resign: "기권",
    resigns: "기권",
    forfeits: "몰수패",
    offerDraw: "무승부 제안",
    acceptDraw: "무승부 수락",
    declineDraw: "무승부 거절",
    newGame: "새 게임",
    leave: "나가기",
    rules: "규칙",
    moveHistory: "기보",
    noMovesYet: "아직 수가 없습니다",
    movesWillAppear: "수가 여기에 표시됩니다",
    yourTurn: "당신의 차례",
    opponentTurn: "상대방 차례",
    gameOver: "게임 종료",
    youWin: "승리!",
    youLose: "패배",
    whiteWins: "백 승리!",
    blackWins: "흑 승리!",
    drawGame: "무승부!",
    playAgain: "다시 플레이",
    backToLobby: "로비로 돌아가기",
    classic: "클래식",
    kingsCourt: "왕의 궁전",
    fightToBeKing: "왕좌 쟁탈",
    kingCaptured: "킹 잡힘!",
    winner: "승자",
    rematch: "재대국",
    decline: "거절",
    waiting: "대기 중...",
    acceptRematch: "재대국 수락",
    wantsRematch: "재대국을 원합니다!",
    rematchAccepted: "재대국 수락! 새 게임 시작...",
    rematchDeclined: "재대국 거절. 로비로 돌아갑니다...",
    waitingForOpponent: "상대 대기 중...",
    startingNewGame: "새 게임 시작 중...",
    continue: "계속"
  },
  settings: {
    title: "설정",
    boardCustomization: "보드 및 기물 커스터마이징",
    livePreview: "실시간 미리보기",
    previewDescription: "커스터마이징 확인",
    boardTheme: "보드 색상",
    pieceTheme: "기물 색상",
    customColors: "사용자 정의 색상",
    presetThemes: "프리셋 테마",
    lightSquares: "밝은 칸",
    darkSquares: "어두운 칸",
    whitePieces: "백 기물",
    blackPieces: "흑 기물",
    coordinateColor: "좌표 색상",
    coordinateDescription: "숫자(1-8)와 문자(a-h) 색상 설정",
    chessPieceSkins: "기물 스킨",
    chessPieceSkinsDescription: "표준 기물을 프리미엄 3D 스킨으로 교체",
    dukeSkins: "듀크 스킨",
    dukeSkinsDescription: "듀크 스킨 선택 - 보드 색상 자동 매칭!",
    whiteSideDuke: "백 듀크",
    blackSideDuke: "흑 듀크",
    autoMatchBoard: "보드 색상 자동 매칭",
    saveAndClose: "저장 후 닫기",
    reset: "초기화",
    close: "닫기",
    premium: "프리미엄",
    default: "기본",
    classic: "클래식",
    viewMode: "보기 모드",
    viewModeDescription: "보드 보기 방식 선택",
    topDown: "위에서 보기",
    topDownDescription: "전통적인 평면 보기",
    perspective3D: "3D 시점",
    perspective3DDescription: "동적 3D 각도의 2D 기물",
    skinsApplyTo: "킹, 퀸, 룩, 비숍, 나이트, 폰에 적용",
    dukeHint: "왼쪽: 즉시 왕 · 오른쪽: 왕좌 쟁탈"
  },
  store: {
    title: "스킨 상점",
    subtitle: "왕의 궁정",
    riseOfDukes: "공작의 부상",
    chessPieces: "체스 기물",
    dukeSkins: "듀크 스킨",
    allPiecesBundle: "전체 기물 스킨 번들",
    allDukeBundle: "전체 듀크 스킨 번들",
    bundleDiscount: "모든 프리미엄 스킨 30% 할인!",
    owned: "보유",
    equip: "장착",
    buy: "구매",
    processing: "처리 중...",
    free: "무료",
    rare: "레어",
    epic: "에픽",
    legendary: "레전더리",
    common: "일반",
    securePayment: "일회성 구매 • 영구 사용 • 안전한 결제"
  },
  chat: {
    title: "채팅",
    lobbyChat: "로비 채팅",
    gameChat: "게임 채팅",
    typeMessage: "메시지 입력...",
    send: "보내기",
    spectatorChat: "관전자 채팅",
    playerChat: "플레이어 채팅"
  },
  friends: {
    title: "친구",
    online: "온라인",
    offline: "오프라인",
    addFriend: "친구 추가",
    removeFriend: "삭제",
    invite: "초대",
    pending: "대기 중",
    accept: "수락",
    decline: "거절",
    friendRequests: "친구 요청",
    noFriends: "아직 친구가 없습니다",
    searchPlayers: "플레이어 검색..."
  },
  notifications: {
    friendRequest: "님이 친구 요청을 보냈습니다",
    gameInvite: "님이 대국에 초대했습니다",
    yourTurn: "당신의 차례입니다!",
    opponentJoined: "상대가 참가했습니다",
    opponentLeft: "상대가 나갔습니다",
    drawOffered: "상대가 무승부를 제안했습니다",
    connected: "서버에 연결됨",
    disconnected: "서버 연결 끊김",
    reconnecting: "재연결 중..."
  },
  errors: {
    invalidEmail: "잘못된 이메일 주소",
    invalidPassword: "비밀번호는 최소 6자 이상이어야 합니다",
    passwordMismatch: "비밀번호가 일치하지 않습니다",
    loginFailed: "로그인 실패. 자격 증명을 확인하세요.",
    registerFailed: "회원가입 실패. 다시 시도하세요.",
    connectionError: "연결 오류. 다시 시도하세요.",
    connectionErrorInternet: "연결 오류. 인터넷 연결을 확인하세요.",
    gameNotFound: "게임을 찾을 수 없습니다",
    roomFull: "방이 가득 찼습니다",
    invalidMove: "잘못된 수",
    pleaseEnterName: "이름을 입력해주세요",
    completeBothSecurityQuestions: "보안 질문을 모두 작성하거나 비워두세요",
    selectDifferentQuestions: "다른 질문을 선택해주세요",
    unexpectedError: "예기치 않은 오류가 발생했습니다",
    failedToSendResetCode: "재설정 코드 전송 실패",
    invalidOrExpiredCode: "유효하지 않거나 만료된 코드",
    failedToResetPassword: "비밀번호 재설정 실패. 다시 시도하세요.",
    pleaseEnterRoomName: "방 이름을 입력해주세요",
    pleaseEnterRoomCode: "방 코드를 입력해주세요",
    roomCodeMustBe6Chars: "코드는 6자리여야 합니다",
    roomNotFound: "방을 찾을 수 없습니다. 코드를 확인하세요.",
    roomRequiresApproval: "이 방은 승인이 필요합니다. 목록에서 요청하세요.",
    failedToCreateRoom: "방 생성 실패",
    failedToJoinRoom: "방 참가 실패",
    failedToLeaveRoom: "방 나가기 실패",
    failedToRemoveRoom: "방 삭제 실패",
    failedToLoadGames: "게임 로드 실패",
    failedToRequestRejoin: "재참가 요청 실패",
    failedToJoinMatchmaking: "매치메이킹 참가 실패",
    noOpponentFound: "상대를 찾을 수 없습니다. 나중에 다시 시도하세요.",
    searchFailed: "검색 실패",
    failedToSendRequest: "요청 전송 실패",
    failedToAcceptRequest: "요청 수락 실패",
    failedToRejectRequest: "요청 거절 실패",
    failedToCancelRequest: "요청 취소 실패",
    failedToRemoveFriend: "친구 삭제 실패"
  },
  success: {
    copiedToClipboard: "클립보드에 복사되었습니다!",
    rejoinRequestSent: "호스트에게 요청이 전송되었습니다!",
    roomRemovedFromList: "목록에서 방이 제거되었습니다",
    leftRoomSuccessfully: "방을 성공적으로 나왔습니다",
    requestRejected: "요청이 거절되었습니다",
    requestCancelled: "요청이 취소되었습니다",
    friendRemoved: "친구가 삭제되었습니다",
    tournamentCreated: "토너먼트가 생성되었습니다!",
    tournamentJoined: "토너먼트에 참가했습니다!",
    tournamentLeft: "토너먼트에서 나왔습니다",
    tournamentStarted: "토너먼트가 시작되었습니다!",
    tournamentCancelled: "토너먼트가 취소되었습니다",
    tournamentsCleared: "모든 토너먼트가 삭제되었습니다",
    removedFromHistory: "기록에서 삭제되었습니다"
  },
  tournament: {
    title: "토너먼트",
    createTournament: "토너먼트 생성",
    joinTournament: "토너먼트 참가",
    leaveTournament: "토너먼트 나가기",
    startTournament: "토너먼트 시작",
    cancelTournament: "토너먼트 취소",
    clearAll: "모두 삭제",
    myTournaments: "내 토너먼트",
    availableTournaments: "참가 가능한 토너먼트",
    tournamentHistory: "토너먼트 기록",
    bracket: "대진표",
    participants: "참가자",
    status: "상태",
    waiting: "대기 중",
    inProgress: "진행 중",
    completed: "완료",
    cancelled: "취소됨",
    format: "형식",
    singleElimination: "싱글 엘리미네이션",
    doubleElimination: "더블 엘리미네이션",
    swiss: "스위스 방식",
    round: "라운드",
    match: "매치",
    ready: "준비 완료",
    notReady: "준비 안됨",
    markReady: "준비 완료 표시",
    winner: "승자",
    loser: "패자",
    bye: "부전승",
    pleaseLoginToCreate: "토너먼트를 생성하려면 로그인하세요",
    pleaseLoginToJoin: "토너먼트에 참가하려면 로그인하세요",
    failedToLoadTournaments: "토너먼트 로드 실패",
    failedToCreateTournament: "토너먼트 생성 실패",
    failedToJoinTournament: "토너먼트 참가 실패",
    failedToLeaveTournament: "토너먼트 나가기 실패",
    failedToStartTournament: "토너먼트 시작 실패",
    failedToCancelTournament: "토너먼트 취소 실패",
    failedToClearTournaments: "토너먼트 삭제 실패",
    failedToRemoveFromHistory: "기록에서 삭제 실패",
    failedToLoadTournament: "토너먼트 로드 실패",
    failedToMarkReady: "준비 완료 표시 실패"
  },
  ranked: {
    title: "랭크 게임",
    findMatch: "랭크 매치 찾기",
    inQueue: "대기 중...",
    leaveQueue: "대기열 나가기",
    yourRank: "내 랭크",
    elo: "ELO",
    tier: "티어",
    wins: "승리",
    losses: "패배",
    draws: "무승부",
    season: "시즌",
    leaderboard: "리더보드",
    squire: "종자",
    knight: "기사",
    baron: "남작",
    duke: "공작",
    king: "왕",
    pleaseLoginToPlay: "랭크 게임을 하려면 로그인하세요",
    failedToJoinQueue: "대기열 참가 실패"
  },
  misc: {
    loading: "로딩 중...",
    cancel: "취소",
    confirm: "확인",
    yes: "예",
    no: "아니오",
    ok: "확인",
    save: "저장",
    delete: "삭제",
    edit: "편집",
    back: "뒤로",
    next: "다음",
    previous: "이전",
    search: "검색",
    filter: "필터",
    sort: "정렬",
    all: "전체",
    none: "없음",
    select: "선택",
    selected: "선택됨"
  },
  
  // About Us Page
  aboutUs: {
    back: "← 뒤로",
    title: "Chess Kingdom: 킹스 코트에 오신 것을 환영합니다",
    subtitle: "왕의 궁정",
    riseOfDukes: "공작의 부상",
    description: "고전 전략과 신화적 규모가 만나는 왕국으로 들어오세요. 킹스 코트는 단순한 게임 모드 이상입니다—전술가, 몽상가, 챔피언을 위한 시험장입니다. 새로운 도전을 찾는 그랜드마스터든 정복의 스릴에 이끌리는 초보자든, 여기가 당신의 경기장입니다. ⚔️",
    keyFeatures: "주요 기능",
    feature1Title: "다이나믹 변형",
    feature1Desc: "적응력과 선견지명을 시험하는 진화하는 규칙 세트와 보드 레이아웃을 탐험하세요.",
    feature2Title: "궁정 진급",
    feature2Desc: "타이틀을 얻고, 엠블럼을 해금하고, 숙련도와 스타일을 보상하는 풍부한 랭킹 시스템을 통해 승진하세요.",
    feature3Title: "스킬 기반 플레이",
    feature3Desc: "투명한 피드백, 텔레메트리 조정된 밸런스, 공정한 매치메이킹으로 모든 승리가 정당하게 얻어집니다.",
    feature4Title: "실시간 채팅 및 스토리",
    feature4Desc: "라이벌과 동맹과 연결하고, 절차적 로어를 발견하고, 왕국의 신화를 형성하세요.",
    feature5Title: "프로를 위한 설계",
    feature5Desc: "정밀 튜닝, 리플레이 분석, 토너먼트 준비 인프라로 킹스 코트는 경쟁 플레이를 위한 진지한 플랫폼이 됩니다.",
    closingStatement: "영광, 성장, 또는 대전략을 추구하든, 킹스 코트는 지혜로 통치하고, 명예로 싸우고, 왕국에 당신의 흔적을 남기도록 초대합니다.",
    developmentNotice: "참고: 게임은 아직 개발 중이며, 여러분의 인내와 지원으로 게임은 집처럼 편안한 곳이 될 것입니다. 즐기고, 친구와 동맹을 만드세요. 완성되면 여러분의 전략적 승리 방법이 시험받게 될 것입니다... 당신의 왕국에 오신 것을 환영합니다...",
    contactTitle: "더 많은 정보나 제안 연락처:",
    contactEmail: "CKKC.customerservice@gmail.com"
  },
  
  // Store
  store: {
    title: "스킨 상점",
    themedSets: "테마 세트",
    pieceSkins: "기물 스킨",
    dukeSkins: "공작 스킨",
    unlockSet: "세트 해금",
    owned: "보유 중",
    price: "가격",
    checkout: "결제",
    addToCart: "장바구니 추가",
    cart: "장바구니",
    total: "총계",
    continueShopping: "쇼핑 계속",
    proceedToCheckout: "결제 진행",
    emptyCart: "장바구니가 비어 있습니다",
    itemAdded: "장바구니에 추가됨",
    purchaseSuccess: "구매 성공!",
    purchaseFailed: "구매 실패. 다시 시도해 주세요."
  },
  
  // Rules
  rules: {
    title: "게임 규칙",
    classic: "클래식 체스",
    classicDesc: "표준 체스 규칙 - 상대 킹을 체크메이트하여 승리.",
    instantKing: "인스턴트 킹",
    instantKingDesc: "적 킹을 직접 잡아 승리 - 체크메이트 불필요!",
    fightToBeKing: "왕위 쟁탈전",
    fightToBeKingDesc: "승진한 폰이 새로운 킹이 됩니다! 지키지 못하면 패배.",
    timerRules: "타이머 규칙",
    timerDesc: "각 플레이어는 수마다 제한 시간이 있습니다. 시간이 만료되면 턴이 건너뛰어집니다."
  },
  
  // Assistant
  assistant: {
    title: "Chess Kingdom 어시스턴트",
    searchPlaceholder: "도움말 검색...",
    randomTip: "랜덤 팁 보기",
    noResults: "검색 결과 없음",
    noResultsHint: "다른 키워드를 시도하거나 위의 카테고리를 찾아보세요",
    categories: {
      gettingStarted: "시작하기",
      dukeMechanics: "듀크 메카닉",
      multiplayer: "멀티플레이어",
      customization: "커스터마이징",
      boardFeatures: "보드 기능",
      skinStore: "스킨 상점",
      trialPayments: "체험 & 결제",
      strategyTips: "전략 팁",
      troubleshooting: "문제 해결"
    },
    gettingStarted: {
      q1: "어떻게 플레이를 시작하나요?",
      a1: "'솔로 플레이'를 클릭하여 AI와 대전하거나, '멀티플레이어'로 다른 플레이어와 대전하세요. 게스트로 플레이하거나 48시간 무료 체험에 등록할 수 있습니다.",
      q2: "게임 변형은 무엇인가요?",
      a2: "Chess Kingdom은 7가지 변형을 제공합니다: 표준 체스, 인스턴트 킹, 왕위 쟁탈전, 플레이어 선택, 와일드 폰, Chess Kingdom (듀크 2개), 핸디캡 모드.",
      q3: "보드를 커스터마이징하려면?",
      a3: "설정 버튼을 클릭하여 커스터마이징 옵션에 접근하세요. 보드 색상, 기물 스킨, 듀크 스킨, 테마, 좌표 색상, 뷰 모드, 보드 크기를 변경할 수 있습니다.",
      q4: "보드 뷰를 뒤집으려면?",
      a4: "게임 헤더의 뒤집기 버튼을 클릭하여 흑색 관점에서 보드를 볼 수 있습니다.",
      q5: "보드 크기를 변경하려면?",
      a5: "설정 → 보드 크기로 이동하세요. 슬라이더를 사용하거나 '컴팩트' (85%), '기본' (100%), '크게' (115%)를 클릭하세요."
    },
    dukeMechanics: {
      q1: "듀크 기물이란?",
      a1: "듀크는 비숍을 대체하는 특별한 기물입니다. 캡처하지 않는 이동은 대각선(1칸)으로 이동하지만, 8방향 모두(인접 칸만)로 캡처할 수 있습니다.",
      q2: "내 킹이 캡처되면 어떻게 되나요?",
      a2: "당신의 듀크가 새로운 킹으로 변신합니다! 변신 규칙은 모드에 따라 다릅니다: 인스턴트 킹 또는 왕위 쟁탈전.",
      q3: "왕위 쟁탈전은 어떻게 작동하나요?",
      a3: "킹이 캡처된 후, 듀크는 시작 라인(백색은 1열, 흑색은 8열)으로 돌아가 킹으로 변신해야 합니다.",
      q4: "듀크 기물은 승진할 수 있나요?",
      a4: "와일드 폰 변형에서만 가능합니다! 폰이 마지막 열에 도달하면 퀸, 룩, 비숍, 나이트 또는 듀크로 승진할 수 있습니다.",
      q5: "인스턴트 킹과 왕위 쟁탈전 스킨의 차이점은?",
      a5: "듀크 스킨은 두 가지 버전이 있습니다: '인스턴트 킹' 버전은 일반 플레이 중에 나타나고, '왕위 쟁탈전'은 듀크가 베이스라인에 도달하기 위해 싸울 때 나타납니다."
    },
    multiplayer: {
      q1: "퀵 매치는 어떻게 작동하나요?",
      a1: "퀵 매치는 즉시 다른 플레이어와 매칭됩니다! 선호하는 게임 모드를 선택하고 '매치 찾기'를 클릭하면 같은 모드를 선택한 사람과 매칭됩니다.",
      q2: "프라이빗 룸을 생성하고 관리하려면?",
      a2: "'룸 생성' 탭으로 이동하여 룸 이름을 입력하고, 변형을 선택하고, 관전 설정을 하고, 6자리 코드를 친구와 공유하세요.",
      q3: "친구의 룸에 참가하려면?",
      a3: "'룸 참가' 탭으로 이동하여 친구가 공유한 6자리 코드를 입력하고 '참가'를 클릭하세요.",
      q4: "관전 설정이란?",
      a4: "프라이빗: 관전자 없음. 요청 참가: 관전자는 승인을 요청해야 함. 오픈: 누구나 자유롭게 관전 가능.",
      q5: "관전자로 게임을 보려면?",
      a5: "'관전' 탭으로 이동하여 모든 공개 게임을 볼 수 있습니다. 게임 유형으로 필터링하여 특정 변형을 찾을 수 있습니다.",
      q6: "게임 중에 채팅할 수 있나요?",
      a6: "네! 멀티플레이어 게임 중 인게임 채팅을 사용할 수 있습니다. 플레이어가 다른 언어를 사용하면 메시지가 자동으로 번역됩니다!",
      q7: "내 테마가 상대와 동기화되나요?",
      a7: "네! 호스트(룸 생성자)인 경우, 보드 테마, 기물 스킨, 듀크 스킨이 모든 플레이어와 자동으로 동기화됩니다."
    },
    customization: {
      q1: "어떤 기물 스킨을 사용할 수 있나요?",
      a1: "20개 이상의 세트가 있습니다: 골든 3D, 옵시디언 3D, 빈티지, 카와이, 페이블, 고딕, 콜로설, 아메시스트 퍼플, 사파이어 블루, 스톤 & 샌드 킹덤 등!",
      q2: "어떤 듀크 스킨을 사용할 수 있나요?",
      a2: "50개 이상의 스킨이 카테고리별로 있습니다: 메탈릭(골드, 실버), 컬러(퍼플, 블루, 에메랄드), 화이트(스파르탄, 이글), 블랙(스틸, 크라운), 젬스톤, 킹덤, 3D 프리미엄 등!",
      q3: "기물 스킨을 변경하려면?",
      a3: "설정 → 기물 스킨. 백색과 흑색 측면에 별도의 스킨을 설정할 수 있습니다! '양측 미리보기'를 사용하여 함께 어떻게 보이는지 확인하세요.",
      q4: "듀크 스킨을 변경하려면?",
      a4: "설정 → 듀크 스킨. 백색, 흑색 또는 중립으로 분류된 스킨을 선택하세요. 각 듀크에는 인스턴트 킹과 왕위 쟁탈전 변형이 있습니다.",
      q5: "테마 팩이란?",
      a5: "테마 팩은 기물 스킨, 듀크 스킨, 보드 테마를 번들로 제공합니다! 사용 가능한 팩: 로열 골드, 다크 나이트, 빈티지 클래식, 킹덤 배틀 팩!",
      q6: "랜덤 테마를 얻으려면?",
      a6: "'랜덤 테마 팩'을 클릭하여 완전히 랜덤한 테마를 적용하거나, '랜덤 킹덤 배틀'로 랜덤한 팩션 대결을 적용하세요.",
      q7: "좌표 색상을 커스터마이징할 수 있나요?",
      a7: "네! 설정 → 좌표 색상. 열 번호(1-8)와 행 문자(a-h)의 원하는 색상을 선택하세요."
    },
    boardFeatures: {
      q1: "뷰 모드란?",
      a1: "두 가지 모드: 3D 퍼스펙티브(깊이와 그림자 포함)와 탑다운(평면, 전통적). 설정 → 뷰 모드에서 전환하세요.",
      q2: "보드 크기 조정은 어떻게 작동하나요?",
      a2: "설정 → 보드 크기로 80%(컴팩트)에서 120%(크게)까지 스케일링할 수 있습니다. 기본값은 100%입니다.",
      q3: "어떤 보드 테마를 사용할 수 있나요?",
      a3: "여러 색상 테마: 클래식 우드, 로열 골드, 다크 나이트, 오션 블루, 포레스트 그린, 스톤 그레이 등.",
      q4: "좌표는 어떻게 작동하나요?",
      a4: "좌표는 보드 가장자리에 열 번호(1-8)와 행 문자(a-h)를 표시합니다. 보드 뒤집기 버튼을 사용하면 올바르게 뒤집힙니다!",
      q5: "보드가 모바일에서 작동하나요?",
      a5: "네! 보드는 완전히 반응형입니다. 가로 모드에서 보드는 화면 높이에 맞게 자동으로 크기가 조정됩니다."
    },
    skinStore: {
      q1: "스킨 상점에 접근하려면?",
      a1: "로비에서 상점 버튼을 클릭하거나 설정 → '상점 방문' 버튼을 통해 접근하세요. 상점에는 세 가지 탭이 있습니다: 테마 세트, 기물 스킨, 듀크 스킨.",
      q2: "테마 세트란?",
      a2: "할인된 완전한 테마 패키지입니다! 매칭되는 기물 스킨, 듀크 스킨, 보드 테마가 포함됩니다.",
      q3: "번들 할인이 있나요?",
      a3: "네! '모든 기물 스킨 번들'과 '모든 듀크 스킨 번들'로 모든 스킨을 40% 할인받을 수 있습니다.",
      q4: "스킨 희귀도는 어떻게 작동하나요?",
      a4: "일반(회색): 무료 또는 기본. 레어(파랑): ₩1,990-2,490. 에픽(보라): ₩2,490-3,990. 레전더리(금색): ₩3,490-4,990.",
      q5: "구매 전에 미리보기할 수 있나요?",
      a5: "네! 스킨 카드에 마우스를 올리면 미리보기가 표시됩니다. 기물 스킨은 킹, 퀸, 나이트를 보여줍니다.",
      q6: "구매한 스킨을 장착하려면?",
      a6: "상점에서 소유한 스킨은 가격 대신 '장착' 버튼이 표시됩니다. 장착을 클릭하여 즉시 적용하세요."
    },
    trialPayments: {
      q1: "48시간 무료 체험이란?",
      a1: "신규 사용자는 모든 변형에 48시간 무료 접근 권한을 받습니다. 체험 종료 후 표준 체스와 인스턴트 킹은 무료로 유지됩니다.",
      q2: "변형 가격은?",
      a2: "왕위 쟁탈전 & 핸디캡 모드: ₩2,990, 플레이어 선택: ₩3,990, 와일드 폰 & 듀크 2개: ₩4,990. 또는 모든 변형 번들 ₩8,990!",
      q3: "스킨 가격은?",
      a3: "개별 스킨: 희귀도에 따라 ₩1,990-4,990. 번들: ~40% 할인. 테마 세트: ₩8,990-12,990.",
      q4: "게스트로 플레이할 수 있나요?",
      a4: "네! 게스트 모드는 등록 없이 즉시 플레이할 수 있습니다. 단, 게임 기록은 저장되지 않습니다.",
      q5: "결제는 어떻게 작동하나요?",
      a5: "모든 결제는 Stripe를 통해 안전하게 처리됩니다. 일회성 구매로 콘텐츠가 영구적으로 잠금 해제됩니다. 구독이 필요 없습니다."
    },
    strategyTips: {
      q1: "듀크 오프닝 전략?",
      a1: "초반에 듀크를 중앙 대각선을 제어하는 위치에 배치하세요. 8방향 캡처 능력으로 여러 기물을 위협하는 데 탁월합니다.",
      q2: "인스턴트 킹 vs 왕위 쟁탈전 선택 시기는?",
      a2: "듀크가 좋은 위치에 있으면 인스턴트 킹을 선택하세요. 듀크가 이미 베이스라인 근처에 있으면 왕위 쟁탈전을 선택하세요.",
      q3: "듀크 2개 변형 전략?",
      a3: "두 듀크를 신중하게 보호하세요 - 이것들은 당신의 '추가 생명'입니다! 킹이 캡처되면 변신을 위해 더 안전한 듀크를 선택하세요.",
      q4: "와일드 폰 엔드게임?",
      a4: "폰을 듀크로 승진시키는 것을 '킹 보험'으로 고려하세요 - 나중에 킹이 캡처되면 승진한 듀크가 새 킹이 될 수 있습니다!",
      q5: "보드 뒤집기를 전략적으로 사용하기?",
      a5: "보드를 뒤집어 상대 관점에서 포지션을 보세요! 놓칠 수 있는 위협을 식별하는 데 도움이 됩니다."
    },
    troubleshooting: {
      q1: "게임 로딩이 느림",
      a1: "문제 해결 버튼을 시도하여 진단을 실행하세요. 인터넷 연결을 확인하세요. 페이지 새로고침을 시도하세요 (Ctrl+F5).",
      q2: "멀티플레이어가 연결되지 않음",
      a2: "문제 해결을 사용하여 WebSocket 연결 상태를 확인하세요. 로그인했는지 확인하세요. 방화벽/VPN 문제를 확인하세요.",
      q3: "설정이 저장되지 않음",
      a3: "설정은 localStorage를 사용합니다. 브라우저가 허용하는지 확인하세요. 문제 해결의 '설정 초기화' 옵션을 시도하세요.",
      q4: "수 기록은 어디에?",
      a4: "수 기록 사이드바는 활성 게임 중 오른쪽에 나타납니다. 브라우저 너비 > 768px가 필요합니다.",
      q5: "보드 크기 슬라이더가 작동하지 않음?",
      a5: "시도: 1) 페이지 새로고침. 2) 브라우저 캐시 지우기. 3) 게임 중인지 확인. 4) 다른 뷰 모드 시도.",
      q6: "기물이 너무 작거나 크게 보임?",
      a6: "다른 기물 스킨은 다른 최적 크기가 있습니다. 설정 → 보드 크기로 이동하여 조정하세요.",
      q7: "비밀번호를 잊어버림?",
      a7: "계정 페이지 → '비밀번호 찾기?' → 보안 질문에 답변 → 비밀번호가 이메일로 전송됩니다.",
      q8: "지원팀에 연락하려면?",
      a8: "기술적 문제에는 문제 해결을 사용하세요. 결제/계정 문제는 계정 페이지에서 이메일을 보내세요."
    },
    tips: {
      tip1: "듀크는 8방향으로 캡처할 수 있지만 캡처하지 않을 때는 대각선으로만 이동합니다!",
      tip2: "왕위 쟁탈전 모드에서 듀크는 변신하려면 베이스라인에 도달해야 합니다.",
      tip3: "듀크를 여러 칸을 제어하는 위치에 배치하세요 - 그 독특한 움직임은 강력합니다!",
      tip4: "듀크 2개 변형에서 두 듀크를 보호하면 더 많은 역전 옵션이 생깁니다.",
      tip5: "와일드 폰에서 듀크로 승진하면 캡처 시 '킹 보험'을 얻습니다.",
      tip6: "퀵 매치: 상대와 같은 게임 모드를 선택하면 즉시 매칭됩니다!",
      tip7: "생성한 룸은 '내 룸'에, 참가한 룸은 '참가한 룸'에 나타납니다.",
      tip8: "룸을 '오픈'으로 설정하면 누구나 당신의 에픽 게임을 볼 수 있습니다!",
      tip9: "요청 모드: 플레이어가 관전자를 승인해야 함 - 프라이빗 레슨에 완벽.",
      tip10: "최대 5개의 룸을 생성할 수 있습니다. 더 만들려면 취소하거나 완료하세요.",
      tip11: "설정을 클릭하여 언제든지 보드와 기물 색상을 변경하세요.",
      tip12: "모든 수는 화면 오른쪽 사이드바에 기록됩니다.",
      tip13: "다른 언어를 사용하는 플레이어를 위해 메시지가 자동 번역됩니다!",
      tip14: "각 프라이빗 룸은 친구와 공유할 고유한 6자리 코드를 받습니다.",
      tip15: "테마 팩: 한 번의 클릭으로 매칭되는 기물, 듀크, 보드 테마를 얻으세요!",
      tip16: "스톤 & 샌드 vs 우드린 워리어스로 에픽한 팩션 전쟁을 시도해보세요!",
      tip17: "게임이 랜덤 테마를 선택하게 하세요 - 새로운 즐겨찾기를 발견하세요!",
      tip18: "아메시스트 퍼플과 사파이어 블루로 기물이 빛납니다!",
      tip19: "뒤집기 버튼을 클릭하여 흑색 관점에서 보세요 - 분석에 좋습니다!",
      tip20: "모바일에서 더 큰 보드 뷰를 위해 기기를 회전하세요!",
      tip21: "설정의 슬라이더를 사용하여 보드를 80%에서 120%로 스케일링하세요!",
      tip22: "콜로설 세트는 에픽한 대리석과 청동 조각 기물을 특징으로 합니다!",
      tip23: "4가지 귀여운 카와이 이모지 기물 세트 - 브라운, 화이트, 블랙, 베이지!",
      tip24: "고딕 화이트와 블랙 세트는 복잡한 다크 판타지 디자인을 특징으로 합니다!",
      tip25: "페이블 중세: 십자군 기사 vs 암흑 전사 - 에픽 배틀 기물!"
    }
  },

  // Account Manager
  account: {
    title: "계정 관리",
    accountInfo: "계정 정보",
    usernameEmail: "사용자명/이메일",
    displayName: "표시 이름",
    accountType: "계정 유형",
    userId: "사용자 ID",
    guest: "게스트",
    registered: "등록됨",
    notAvailable: "N/A",
    notificationSettings: "알림 설정",
    notificationSound: "알림 소리",
    notificationSoundDesc: "알림을 받을 때 소리 재생",
    security: "보안",
    passwordManagement: "비밀번호 관리",
    passwordNote: "보안상의 이유로 비밀번호를 표시하지 않습니다. 비밀번호를 재설정해야 하는 경우 '비밀번호 찾기' 기능을 사용하세요.",
    forgotPassword: "비밀번호 찾기?",
    passwordRecovery: "비밀번호 복구",
    passwordRecoveryHelp: "보안 질문에 답변하여 이메일로 비밀번호 받기",
    securityQuestion1: "보안 질문 1",
    securityQuestion2: "보안 질문 2",
    selectQuestion: "질문 선택...",
    yourAnswer: "답변",
    sendPasswordEmail: "이메일로 비밀번호 전송",
    securityQuestions: {
      q1: "첫 번째 반려동물 이름은?",
      q2: "태어난 도시는?",
      q3: "어머니의 결혼 전 성은?",
      q4: "초등학교 이름은?",
      q5: "좋아하는 책은?",
      q6: "어린 시절 별명은?",
      q7: "좋아하는 선생님 이름은?",
      q8: "자란 거리 이름은?"
    },
    dangerZone: "위험 구역",
    deleteAccount: "계정 삭제",
    deleteAccountDesc: "계정과 모든 관련 데이터를 영구적으로 삭제합니다.",
    deleteWarning: "다음이 영구적으로 삭제됩니다:",
    deleteWarningItems: {
      account: "계정과 프로필",
      gameHistory: "모든 게임 기록",
      friends: "친구 연결",
      purchases: "구매한 변형",
      settings: "설정과 환경설정"
    },
    typeDelete: "확인을 위해 DELETE 입력:",
    typeDeletePlaceholder: "여기에 DELETE 입력",
    deleteForever: "계정 영구 삭제",
    deleteConfirmMsg: "이 작업은 취소할 수 없습니다.",
    deleteSuccess: "계정이 성공적으로 삭제되었습니다. 로그아웃됩니다.",
    deleteFailed: "계정 삭제 실패",
    passwordResetSuccess: "비밀번호 재설정 성공! 비밀번호가 이메일 주소로 전송되었습니다. 받은 편지함(및 스팸 폴더)을 확인하세요.",
    securityAnswersIncorrect: "보안 답변이 올바르지 않습니다. 다시 시도하세요.",
    passwordResetFailed: "비밀번호 재설정 실패. 다시 시도하세요.",
    answerBothQuestions: "두 보안 질문에 모두 답변하세요"
  }
};

export default ko;
